export default __webpack_public_path__ + "static/media/google-meet.71e1df86.svg";